/**
 * Checks if a semver is greater or equal than another semver.
 * Works with "x.x.x" strings. Does not work with or "x.x.x-x" strings.
 * @internal
 */
export function isSemverGreaterOrEqualThan(currentVersion, versionFeatureIntroduced) {
    const curr = parseSimpleSemVer(currentVersion);
    const introduced = parseSimpleSemVer(versionFeatureIntroduced);
    if (curr.major > introduced.major) {
        return true;
    }
    else if (curr.major < introduced.major) {
        return false;
    }
    else if (curr.minor > introduced.minor) {
        return true;
    }
    else if (curr.minor < introduced.minor) {
        return false;
    }
    else if (curr.patch > introduced.patch) {
        return true;
    }
    else if (curr.patch < introduced.patch) {
        return false;
    }
    else {
        return true;
    }
}
/**
 * Parses a simple semver string into a semver object.
 * Works with "x.x.x" strings. Does not work with or "x.x.x-x" strings.
 * @internal
 */
function parseSimpleSemVer(version) {
    const [major, minor, patch] = version.split(".").map(Number);
    return { major, minor, patch };
}
